import { prepPathWithCDN } from '@/utils/location-helpers'

export const MULTICOLORED_SELLER_PROFILE_PICTOGRAM_URL = prepPathWithCDN(
  '/paypal-ui/pictograms/multicolored/svg/seller-profile.svg',
)

export const BLUE_MERCHANT_STORE_FRONT_URL = prepPathWithCDN(
  '/businessprofile/merchant-icon.png',
)

export const BLUE_SELLER_PROFILE_PICTOGRAM_URL = prepPathWithCDN(
  '/paypal-ui/pictograms/blue/svg/seller-profile-blue.svg',
)
